import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {App} from 'ionic-angular';
import {ImagesService} from '../../shared/services/images.service';
import {LocalStorageService} from '../../shared/services/localStorage.service';
import {Headers, Http, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'core-img',
  templateUrl: './img.component.html',
})
export class ImgComponent implements OnChanges, OnDestroy {
  @Input() id: number;
  @Input() images: Array<any>;
  @Input() type: string;
  @Input() typeImage: string;
  @Input() width: any = 100;
  @Input() height: any = 'auto';
  @Input() fit: string;
  @Input() ratio: number;

  public src = null;
  public subscriber;
  public isReady = false;
  public hasNoImage = false;
  public defaultImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

  constructor(
    public app: App,
    private imagesService: ImagesService,
    private lsService: LocalStorageService,
    private http: Http
  ) {

  }

  ngOnChanges(changes: SimpleChanges) {
    this.getImage();
  }

  public isValueString(value): boolean {
    return typeof value === 'string';
  }

  ngOnDestroy() {
    if (this.subscriber) {
      this.subscriber.unsubscribe();
    }
  }

  getImage() {
    const image = this.imagesService.getImage(this.id, this.images, this.type, this.typeImage);
    this.src = this.defaultImg;
    this.subscriber = this.transform(image)
      .subscribe((data) => {
          this.src = data;
          this.isReady = true;
          this.hasNoImage = true;
        },
        () => {
          console.log('error', image);
        });
  }

  transform(url: string) {
    return new Observable<string | ArrayBuffer>((observer) => {
      const {next, error} = observer;
      let headers;
      if (url && url.length > 0) {
        if (this.lsService.getOauthToken()) {
          headers = new Headers({
            'Authorization': `Bearer ${this.lsService.getOauthToken().access_token}`,
            'Content-Type': 'image/*'
          });
        }
        else { // Cas des images de banniere sur la page de connexion (pas encore authentifié)
          headers = new Headers({
            'Content-Type': 'image/*'
          });
        }
        this.http.get(url, {
            headers: headers,
            responseType: ResponseContentType.Text
          })
          .subscribe(response => {
            observer.next(response.text());
          }, () => {
            observer.next(this.defaultImg);
          });
      } else {
        observer.next(this.defaultImg);
        return {
          unsubscribe() {
          }
        };
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/core/img/img.component.ts